module.exports = __webpack_public_path__ + "img/times-circle-regular.7f51ba00.svg";